// @flow
import glamorous from 'glamorous'
import { colors, transition } from 'style'
import Link from './atoms/Link'

const InlineLink = glamorous(Link)({
  ...transition.fast('color'),
  color: colors.primary,
  textDecoration: 'none',
  ':hover': {
    color: colors.primaryDark,
  },
})

export default InlineLink



// WEBPACK FOOTER //
// ./src/components/InlineLink.js